export const getSizes = () => ({
  tiny: 50,
  small: 100,
  medium: 225,
  large: 500,
  huge: 1024,
  gigantic: 1560
});
